import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Error from "../Error/Error";
import { useLanguageContext } from "../../Context/LanguageContext";
import LanguageSelector from "../Language/LanguageSelector";
import {
  useAuthActionsContext,
  useAuthContext,
} from "../../Context/AuthContext";

import access_control_constants from "../../Constants/Access_ControlConstants";
import access_controlActions from "../../Actions/Access_ControlActions";
import access_controlStores from "../../Stores/Access_ControlStores";
// import tokenValid from './../../Actions/TokenValid';
// import decode from 'jwt-decode';
import { Link } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import commonUtils from "../../helpers/commonUtils";
import PrivacyDisclaimer from "./PrivacyPolicy";
import { useTourGuidSavedSettingActionsContext } from "../../Context/TourGuidContext";
import { useLoggedInUserInfoActionsContext } from "../../Context/LoggedInUserInfoContext";
const decode = require("jwt-decode");

function Login_new(props) {
  const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
  const updateLoggedInUserInfo = useLoggedInUserInfoActionsContext();
  const [username, setUsername] = useState("");
  const [pwd, setPwd] = useState("");
  const [hasValue, setHasValue] = useState("");
  const [showspinner, setShowspinner] = useState({ display: "none" });

  const { language, localization } = useLanguageContext();
  const isAuthenticated = useAuthContext();
  const UpdateLogged = useAuthActionsContext();

  const [loginError, setLogginError] = useState("");
  const [showError, setShowError] = useState("");
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState("");

  useEffect(() => {
    // Benutzer wird nach 24 stunden ausgeloggt!
    if (isAuthenticated) {
      setInterval(() => {
        let _istokenvalid = true;

        var token = sessionStorage.getItem("token");
        const currentDate = new Date();

        try {
          if (token !== null && token !== undefined) _istokenvalid = false;

          const { exp } = decode(token);

          if (exp < Math.floor(currentDate.getTime() / 1000))
            _istokenvalid = false;
        } catch {
          _istokenvalid = false;
        }

        if (!_istokenvalid) {
          access_controlActions.logout();
          UpdateLogged(false);
        }
      }, 86400000); //180000
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (loginError === "error") {
      // showError(true);
      setShowspinner({ display: "none" });
      setShowError(true);
    }
    if (loginError === "success") {
      UpdateLogged(true);
    }
  }, [UpdateLogged, loginError, showError]);

  useEffect(() => {
    function savetokenLocal() {
      var result = access_controlStores.getLoginInfo();
      sessionStorage.setItem("token", result.token);
      sessionStorage.setItem("userid", result.id);
      sessionStorage.setItem("isAdmin", result.isAdmin);
      sessionStorage.setItem("isWebsiteAdmin", result.isWebsiteAdmin);
      sessionStorage.setItem(
        "isManageTicket",
        result.hasManageTicketPermission,
      );
      sessionStorage.setItem("isSuperAdmin", result.isSuperAdmin);
      sessionStorage.setItem("isReaderOnly", result.isReaderOnly);
      sessionStorage.setItem("organization", result.organization);
      sessionStorage.setItem("username", result.username);
      sessionStorage.setItem("roleId", result.roleId);
      sessionStorage.setItem("werkId", result.werk);
      sessionStorage.setItem(
        "onBoardStoryGuid",
        JSON.stringify(result.userGuidedTours),
      );
      sessionStorage.setItem("organizationID", result.organizationID);
      updateLoggedInUserInfo(result);
      setTourGuidSaveSetting(result.userGuidedTours);
      setLogginError("success");
    }

    access_controlStores.addChangeListener(
      access_control_constants.LOGIN_SUCCESS,
      savetokenLocal,
    );

    return () => {
      access_controlStores.removeChangeListener(
        access_control_constants.LOGIN_SUCCESS,
        savetokenLocal,
      );
    };
  }, []);

  useEffect(() => {
    function loadError() {
      setLogginError("error");
    }

    access_controlStores.addChangeListener(
      access_control_constants.LOGIN_FAILURE,
      loadError,
    );

    return () => {
      access_controlStores.removeChangeListener(
        access_control_constants.LOGIN_FAILURE,
        loadError,
      );
    };
  }, []);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setLogginError("");
    setShowspinner({ display: "inline-block" });
    if (username !== null && pwd !== null) {
      access_controlActions.login(
        {
          username: username.trim(),
          password: pwd,
          language: language,
          OrganisationId: props.orgDetails.id,
          IsPublicWebsite: false,
        },
        false,
      );
    } else {
      setLogginError("error");
    }
  };

  let renderError = showError ? (
    <Error
      errorTitle={
        access_controlStores.getLoginError() ? "" : localization.loginFailed
      }
      message={
        access_controlStores.getLoginError()
          ? access_controlStores.getLoginError()
          : localization.checkUserNamePassword
      }
    />
  ) : access_controlStores.getSessionExpiredMessage() ? (
    <Error
      errorTitle=""
      message={access_controlStores.getSessionExpiredMessage()}
    />
  ) : null;

  //-----------------------Forgot Password section start-------------------------
  function ForgotPasswordButton(props) {
    // const forgotPassword = props.list;
    return (
      <>
        <button
          type="button"
          className="btn btn-lg btn-primary btn-block"
          // onClick={() => {
          // 	setForgetPassword(list);
          // }}
          data-toggle="modal"
          data-target="#forgotPassword"
        >
          {localization.forgotPasswordField}
        </button>
      </>
    );
  }
  //-----------------------Forgot Password section end-------------------------

  let renderMe = (
    <>
      <header className="bs-docs-nav">
        <div className="container-fluid page-header">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 page-header-nav">
              <nav className="meta-nav">
                <ul id="navigator">
                  <li className="navi-item-list">
                    <LanguageSelector />
                  </li>
                  <li className="navi-item-list meta-standard">
                    <a
                      href="#"
                      className="privacy-disclaimer"
                      onClick={window.initLightbox}
                    >
                      <span className="hidden-xs">
                        {localization.privacydisclaimer}
                      </span>
                    </a>
                  </li>
                </ul>
              </nav>
              <PrivacyDisclaimer />
              <ForgotPassword />
            </div>
            <div className="col-xs-8 col-xs-offset-2 col-sm-12 col-sm-offset-3 col-md-12 col-md-offset-0 col-lg-12 text-center logo-wrapper">
              <div id="header_image_wrapper"></div>
            </div>
          </div>
        </div>
      </header>
      <main className="container-fluid full-content">
        <div className="center-small-devices row flex">
          <div className="offset-xl-4 offset-lg-4 col-md-7 col-lg-5  col-xl-3 col-sm-8 col-12 my-auto">
            <div className="ie11-wrapper">
              <div className="card">
                <div className="card-body pb-1">
                  <form
                    className="form-signin"
                    autoComplete="off"
                    id="loginForm"
                    onSubmit={handleSubmit}
                  >
                    <div className="form-signin__header d-flex">
                      <div className="text-center">
                        <h2 className="h2 font-weight-normal">
                          {localization.welcome}
                        </h2>
                      </div>
                    </div>
                    {renderError}
                    <div id="app">
                      <div className={"form-group label-wrapper " + hasValue}>
                        <input
                          name="username"
                          className="form-control"
                          id="userid"
                          type="text"
                          required
                          defaultValue={username}
                          placeholder={localization.usernamePlaceholder}
                          onChange={(e) => {
                            setHasValue("hasValue");
                            setUsername(e.target.value);
                          }}
                          // autoFocus
                        />
                      </div>
                      <div className={"form-group label-wrapper " + hasValue}>
                        <input
                          name="password"
                          className="form-control"
                          id="password"
                          required="required"
                          type="password"
                          defaultValue={pwd}
                          autoComplete="current-password"
                          placeholder={localization.passwortPlaceholder}
                          onChange={(e) => {
                            setHasValue("hasValue");
                            setPwd(e.target.value);
                          }}
                        />
                      </div>
                      {/* <div className='form-check-inline float-left pb-3'>
          <div className='onoffswitch'>
            <input
              name='onoffswitch'
              className='onoffswitch-checkbox'
              id='rememberme'
              type='checkbox'
            />
            <label
              className='onoffswitch-label'
              htmlFor='rememberme'
            >
              <span className='onoffswitch-inner'></span>
              <span className='onoffswitch-switch'></span>
            </label>
          </div>
          <span className='ml-2'>Remember me</span>
        </div> */}
                      <div className="row">
                        <div className="col-6 pr-0">
                          <ForgotPasswordButton />
                        </div>

                        <div className="col-6">
                          <button
                            className="btn btn-lg btn-primary btn-block"
                            type="submit"
                          >
                            <span
                              className="spinner-border"
                              id="loadingSpinner"
                              role="status"
                              aria-hidden="true"
                              style={showspinner}
                            ></span>
                            {localization.loginButton}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="p-4">
                  {/* <Link to='/Addnewuser' className='btn btn-primary mr-4'>
										Add New User
									</Link> */}
                  {/* <Link to='/Masterpage' className='btn btn-primary mr-3'>
										Master Page
									</Link>
									<Link to='/OrganizationsAdmin' className='btn btn-primary'>
										Organizations Admin
									</Link> */}
                  {/* <Addnewuser /> */}
                </div>

                {/* Now Extra Code */}
                {/* <div className='container-fluid mb-3 ie11-height-fix'>
									<div className='row card-padding'>
										<div className='col-8 p-0 my-auto d-flex align-items-center'>
											<h4 className=''>One login. All brands.</h4>
										</div>
										<div className='col-4 pb-1 pr-2 pl-0'>
											<img className='img-fluid' src='/pub/img/iam_logo.png' />
										</div>
									</div>
								</div> */}

                <div className="card-footer d-md-none show-height">
                  {/* <div className='row'>
										<div className='col-sm-12 col-centered text-center'>
											<a href='#' className='privacy-disclaimer-mobile'>
												<small>Provider/Data Privacy</small>
											</a>
										</div>
									</div>
									<div className='row'>
										<div className='col-sm-12 col-centered text-center'>
											<small>&copy; 2020 Daimler AG. All rights reserved.</small>
										</div>
									</div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <div className="container footer-copy">
          <div className="row h-100">
            <div
              className="col-md-12 col-lg-12 text-center"
              // style={{ fontSize: '80%' }}
            >
              <span id="copyright">
                <small>&copy; 2023 Graubner GmbH. All rights reserved.</small>
              </span>
              <span>
                <small>Version 1.0.0</small>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
  //return isAuthenticated ? <Redirect to='/organizationsadmin' /> : renderMe;
  //return isAuthenticated ? <Redirect to='/dashboard' /> : renderMe;

  // if (isAuthenticated && sessionStorage.getItem("isWebsiteAdmin") === "true") {
  //   return <Redirect to="/organizationsadmin" />;
  // } else if (isAuthenticated && sessionStorage.getItem("isAdmin") === "true") {
  //   return <Redirect to="/masterpage" />;
  // } else if (isAuthenticated) {
  //   return <Redirect to="/dashboard" />;
  // } else {
  //   return renderMe;
  // }

  if (isAuthenticated && commonUtils.isUserWebsiteAdmin()) {
    return <Navigate to="/organizationsadmin" />;
  } else if (isAuthenticated && commonUtils.isSupportUser()) {
    return <Navigate to="/unSync" />;
  } else if (isAuthenticated && commonUtils.isManageTicketUser()) {
    return <Navigate to="setting/manageTicket" />;
  } else if (isAuthenticated) {
    const isTrue =
      commonUtils.isUserOrganisationAdmin() || commonUtils.isUserWerkAdmin();
    return <Navigate to={isTrue ? "/dashboard" : "/equipmentGrpEqiupment"} />;
  } else {
    return renderMe;
  }
}
//isAuthenticated ? <Redirect to='/dashboard' /> : renderMe

export default Login_new;
